export default __webpack_public_path__ + "static/carousel2-8e1eafaf3b23fec367d90aba13703883.webp";